import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  createBlacklistObject,
  getBlockedUserRemovedMsg,
} from './blacklist.adapter';
import {
  handleFetchBlacklist,
  handleRemoveUserFromBlacklist,
} from './blacklist.helpers';
import {
  fetchBlacklistStart,
  loadingBlacklist,
  setBlacklist,
} from './blacklist.actions';
import { blacklistTypes } from './blacklist.types';
import { toast } from 'react-toastify';
import { handleErrors, getNotifMsg } from '../../utils';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* fetchBlacklist() {
  const { locale } = yield select(mapState);
  try {
    yield put(loadingBlacklist());
    const returnedData = yield handleFetchBlacklist();
    yield put(setBlacklist(createBlacklistObject(returnedData)));
  } catch (error) {
    if (error.response && error.response.data.status === 0) {
      yield put(setBlacklist([]));
    }
    // don't show any 404 toast when the fetched blocked users list is empty.
    if (error.response && error.response?.status === 404) return;
    handleErrors(error, locale);
  }
}

export function* onFetchBlacklistStart() {
  yield takeLatest(blacklistTypes.FETCH_BLACKLIST_START, fetchBlacklist);
}

export function* removeUserFromBlacklist({ payload }) {
  const { ip, removeAll } = payload;
  const { locale } = yield select(mapState);

  try {
    const isRemoved = yield handleRemoveUserFromBlacklist(payload);
    if (isRemoved) {
      yield put(fetchBlacklistStart());
      if (removeAll) {
        toast.success(getNotifMsg('ALL_BLOCKED_REMOVED', locale));
        return;
      }
      toast.success(getBlockedUserRemovedMsg(ip, locale));
    }
  } catch (error) {
    handleErrors(error, locale);
  }
}

export function* onRemoveUserFromBlacklistStart() {
  yield takeLatest(
    blacklistTypes.REMOVE_USER_FROM_BLACKLIST_START,
    removeUserFromBlacklist
  );
}

export default function* blacklistSagas() {
  yield all([
    call(onRemoveUserFromBlacklistStart),
    call(onFetchBlacklistStart),
  ]);
}
